import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { DocumentsPanel } from '@/components/DocumentsPanel';
import { useMatters } from '@/contexts/MatterContext';

// P3 Section 3.7: per-matter document management page. Upload, list, status,
// download, and soft delete. Mirrors the matter-skills admin page.

export function AdminMatterDocuments() {
  const { matterId = '' } = useParams();
  const { matters } = useMatters();
  const matterName = matters.find((m) => m.id === matterId)?.name ?? matterId;

  return (
    <div className="min-h-screen bg-stone-950 px-5 py-6 sm:px-6">
      <div className="mx-auto w-full max-w-3xl space-y-5">
        <div className="flex items-center justify-between">
          <h1 className="font-display text-3xl italic text-stone-100">Matter documents</h1>
          <Link
            to="/matters"
            className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-stone-500 hover:text-amber-400"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            Matters
          </Link>
        </div>
        <p className="text-sm text-stone-400">
          Documents for <span className="text-stone-200">{matterName}</span>. Uploaded files are
          extracted to text and injected into every answer for this matter (newest first, up to a
          20k token budget).
        </p>
        {matterId ? (
          <DocumentsPanel matterId={matterId} />
        ) : (
          <p className="text-sm text-stone-500">No matter selected.</p>
        )}
      </div>
    </div>
  );
}
